import { useEffect, useState } from 'react';

type tagAnimatedProps = {
    enable: boolean;
    label: string;
    className: string;
};

function TagAnimated({ enable, label, className }: tagAnimatedProps) {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        if (enable && !isVisible) {
            setIsVisible(true);
            setTimeout(() => {
                setIsVisible(false);
            }, 1200);
        }
    }, [enable]);
    return (
        <div
            className={`animated is-flex is-centered ${isVisible ? className : ''}`}
            style={{
                height: 'auto',
                maxHeight: isVisible ? 130 : 1,
                overflowY: 'hidden',
                paddingTop: isVisible ? 0 : 4,
            }}
        >
            <span className='tag is-success is-small'>
                <span className='icon'>
                    <i className='tri-advisor' aria-hidden='true'></i>
                </span>
                {label}
            </span>
        </div>
    );
}

export default TagAnimated;
